import { useLocation } from "react-router-dom";
import { BoxTabs } from "../../../components/AntdTab/AntdTab";
import Details from "./Details/Details";
import PlanningForm from "./PlanningForm/PlanningForm";
import Section from "../VendorTemplates/Section/Section";

const TemplateDetail = () => {
  const {state} = useLocation()
  const items = [
    {
      key: "1",
      label: "Details",
      headerTitle: "Templates",
      children: <Details />,
    },
    {
      key: "2",
      label: "Planning Form",
      headerTitle: "Templates",
      children: <Section />,
    },
  ];
  const myTemplateitems = [
    
    {
      key: "1",
      label: "Planning Form",
      headerTitle: "Templates",
      children: <PlanningForm />,
    },
  ];
  return <BoxTabs items={state?.publicTemplate ? items : myTemplateitems} />;
};

export default TemplateDetail;
